import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { estimationActions } from "@/redux/actions/estimation.actions";
import { useDispatch } from "@/redux/store";
import { useEffect } from "react";
import { MissingMappingTable } from "./missing-mapping-table/MissingMappingTable";

interface FixMissingMappingModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
  disableContinue: boolean;
}

export default function FixMissingMappingModal({ open, onClose, onContinue, disableContinue }: FixMissingMappingModalProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(
        estimationActions.setEstimationState({
          missingMappings: [],
          showMissingMappingModal: false,
        }),
      );
    };
  }, [dispatch]);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        onWheel={(e) => e.stopPropagation()} // to ensure widgets within modal are scrollable
        onTouchMove={(e) => e.stopPropagation()}
        className="m-auto flex max-h-[90%] w-full max-w-5xl flex-col overflow-y-auto rounded-lg !bg-white p-6 shadow-lg"
      >
        <DialogHeader>
          <DialogTitle className="text-center text-base leading-4 font-medium">
            Please provide Xactimate codes for the following line items
          </DialogTitle>
        </DialogHeader>

        <div className="flex w-full flex-col">
          <MissingMappingTable />
          <div className="mt-10 flex w-full flex-row justify-between gap-2 self-end">
            <Button className="!focus-visible:ring-0 !focus:outline-none !px-4 text-[#000]" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button disabled={disableContinue} className="!bg-[#000] !px-4 text-white" onClick={onContinue}>
              Continue
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
